import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const GridT6 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      id="Group_14985"
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 23.38 16.504"
      {...rest}
      fill={fill}
    >
      <rect
        id="Rectangle_3166"
        fill="#b5b5be"
        width="13.066"
        height="14.441"
        transform="translate(8.94 1.246)"
      />
      <path
        id="grid_3"
        fill="#383e43"
        d="M8.375,12A1.375,1.375,0,0,0,7,13.375V27.129A1.375,1.375,0,0,0,8.375,28.5h20.63a1.375,1.375,0,0,0,1.375-1.375V13.375A1.375,1.375,0,0,0,29.005,12Zm0,15.129V13.375h6.189V27.129Zm7.564,0H29.005V13.375H15.94Z"
        transform="translate(-7 -12)"
      />
    </svg>
  );
};

GridT6.displayName = 'GridT6';
